var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.0829C76.1632 3.08119 86.8368 3.08119 95.5 8.0829L138.081 32.6671C146.744 37.6688 152.081 46.9124 152.081 56.9158V106.084C152.081 116.088 146.744 125.331 138.081 130.333L95.5 154.917C86.8368 159.919 76.1632 159.919 67.5 154.917L24.9189 130.333C16.2557 125.331 10.9189 116.088 10.9189 106.084V56.9158C10.9189 46.9124 16.2557 37.6688 24.9189 32.6671L67.5 8.0829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13.3301C77.641 10.6506 83.359 10.6506 88 13.3301L135.787 40.9199C140.428 43.5994 143.287 48.5513 143.287 53.9103V109.09C143.287 114.449 140.428 119.401 135.787 122.08L88 149.67C83.359 152.349 77.641 152.349 73 149.67L25.2132 122.08C20.5721 119.401 17.7132 114.449 17.7132 109.09V53.9103C17.7132 48.5513 20.5721 43.5994 25.2132 40.9199L73 13.3301Z",
    fill: "url(#paint0_linear_170_11805)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16.7528C78.0222 14.4306 82.9778 14.4306 87 16.7528L133.323 43.4972C137.345 45.8195 139.823 50.1111 139.823 54.7556V108.244C139.823 112.889 137.345 117.181 133.323 119.503L87 146.247C82.9778 148.569 78.0222 148.569 74 146.247L27.6773 119.503C23.655 117.181 21.1773 112.889 21.1773 108.244V54.7556C21.1773 50.1111 23.655 45.8195 27.6773 43.4972L74 16.7528Z",
    fill: "url(#paint1_linear_170_11805)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_11805)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_170_11805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.892 122.893C117.084 125.701 112.511 125.704 109.701 122.893L91.082 104.275C95.1248 101.595 98.5949 98.1249 101.275 94.082L119.892 112.702C122.703 115.513 122.703 120.083 119.892 122.893Z",
    fill: "url(#paint2_linear_170_11805)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2305 57.4141C80.5021 57.4141 88.0469 64.9589 88.0469 74.2305C88.0469 83.5021 80.5021 91.0469 71.2305 91.0469C61.9589 91.0469 54.4141 83.5021 54.4141 74.2305C54.4141 64.9589 61.9589 57.4141 71.2305 57.4141ZM64.7273 77.3367C63.789 78.2751 63.789 79.7954 64.7273 80.7338C65.6657 81.6721 67.186 81.6721 68.1244 80.7338L71.2305 77.6275L74.3367 80.7338C75.2751 81.6721 76.7954 81.6721 77.7338 80.7338C78.6721 79.7954 78.6721 78.2751 77.7338 77.3367L74.6275 74.2305L77.7338 71.1242C78.6721 70.1859 78.6721 68.6655 77.7338 67.7272C76.7954 66.7888 75.2751 66.7888 74.3367 67.7272L71.2305 70.8334L68.1242 67.7272C67.1859 66.7888 65.6655 66.7888 64.7272 67.7272C63.7888 68.6655 63.7888 70.1859 64.7272 71.1242L67.8334 74.2305L64.7273 77.3367Z",
    fill: "url(#paint3_linear_170_11805)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2305 43C88.4505 43 102.461 57.0105 102.461 74.2305C102.461 91.4505 88.4505 105.461 71.2305 105.461C54.0105 105.461 40 91.4505 40 74.2305C40 57.0105 54.0105 43 71.2305 43ZM71.2305 95.8516C83.153 95.8516 92.8516 86.153 92.8516 74.2305C92.8516 62.308 83.153 52.6094 71.2305 52.6094C59.308 52.6094 49.6094 62.308 49.6094 74.2305C49.6094 86.153 59.308 95.8516 71.2305 95.8516Z",
    fill: "url(#paint4_linear_170_11805)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_11805",
    x1: 80.5,
    y1: 9,
    x2: 80.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_11805",
    x1: 80.5,
    y1: 13,
    x2: 80.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_11805",
    x1: 106.541,
    y1: 94.082,
    x2: 106.541,
    y2: 125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_11805",
    x1: 71.2305,
    y1: 57.4141,
    x2: 71.2305,
    y2: 91.0469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_11805",
    x1: 71.2305,
    y1: 43,
    x2: 71.2305,
    y2: 105.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_11805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(40 43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_170_11805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "matrix(-1 0 0 1 122 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResult);
export default __webpack_public_path__ + "static/media/icon_no_result.209c146e858a878fd75d2ee8a28d1197.svg";
export { ForwardRef as ReactComponent };